// extracted by mini-css-extract-plugin
export var copyrightsMenu = "styles-module--copyrights-menu--5355f";
export var footerCopyright = "styles-module--footer-copyright--ca8b6";